<p-dialog [(visible)]="display" class="addBalance-container" [modal]="true" [closable]="true" header="Add balance"
    [style]="{ width: '600px' }" [baseZIndex]="10000" [autoZIndex]="true">
    <!-- <h2>Add balance</h2> -->

    <form [formGroup]="form" (ngSubmit)="addBalance()">
        <!-- Amount Field -->
        <div class="p-field">
            <label for="amount">Amount</label>
            <input pInputText id="amount" type="number" formControlName="amount" placeholder="Enter amount"
                [ngClass]="{ 'invalid-input': form.controls['amount'].invalid && form.controls['amount'].touched }" />
            <small class="error-message"
                *ngIf="form.controls['amount'].invalid && form.controls['amount'].touched">Amount is required and must
                be greater
                than 0</small>
        </div>

        <!-- Actions -->
        <!-- <div class="dialog-actions">
            <button pButton type="button" label="Cancel" class="p-button-secondary" (click)="closeDialog()"></button>
            <button pButton type="submit" label="Add Balance" class="p-button-warning"></button>
        </div> -->

        <div class="dialog-actions">
            <button pButton label="Cancel" class="p-button-secondary" (click)="closeDialog()"></button>
            <button pButton class=" btn-primary" type="submit"
                [disabled]="form.get('amount')?.invalid || form.get('amount')?.value <= 0">
                <span style="margin-left: 8px;">Add balance</span>
            </button>
        </div>
    </form>
</p-dialog>